const LOGGER_RATE_LIMIT_FLAG = "NEXT_PUBLIC_DISABLE_LOGGER_RATE_LIMIT";

type RuntimeConfigWindow = Window & {
  __RUNTIME_CONFIG__?: Record<string, string | undefined>;
};

export function isLoggerRateLimitDisabled(): boolean {
  const runtimeConfig = typeof window !== "undefined" ? (window as RuntimeConfigWindow).__RUNTIME_CONFIG__ : undefined;
  const configuredValue = runtimeConfig?.[LOGGER_RATE_LIMIT_FLAG] ?? process.env.NEXT_PUBLIC_DISABLE_LOGGER_RATE_LIMIT;

  return configuredValue?.trim().toLowerCase() === "true";
}
